import styled from 'styled-components'
import { themeGet } from 'styled-system'
import { Modal, ModalContentWrapper } from 'secondstep-components'

export const StyledModal = styled(Modal)`
  ${ModalContentWrapper} {
    box-sizing: border-box;
    width: ${props => (props.wide ? '750px' : '700px')};
    overflow: auto;
    max-height: 100%;
    font-family: ${themeGet('font.molde.regular')};
    padding: 1.25rem;
  }
`
